import { bandeirasSVG } from "@/utils/cardFlagIcons";
import { CardFlag } from "@/utils/validation";

interface Props {
    flag: CardFlag | null;
}

export const CARD_FLAG_TO_SVG_KEY: Record<CardFlag, string> = {
  VISA: 'visa',
  CRED: 'mastercard',
  AMEX: 'amex',
  DINN: 'diners',
  ELO: 'elo',
  HIPE: 'hipercard',
}

export default function CardFlagIcon({ flag }: Props) {
    if (!flag) return null;

    const svgKey = CARD_FLAG_TO_SVG_KEY[flag];
    const svgMarkup = bandeirasSVG[svgKey as keyof typeof bandeirasSVG];

    if (!svgMarkup) return null;

    return (
        <span
            className="card-flag-icon"
            dangerouslySetInnerHTML={{ __html: svgMarkup }}
        />
    );
}